import {
  DEFAULT_TRUSTED_DOMAINS,
  DEFAULT_TRUSTED_PROTOCOLS,
} from './constants/window-location-constants';
import { isNullOrUndefined } from './general-utils';

const trustedProtocols =
  process.env['NEXT_PUBLIC_TRUSTED_PROTOCOLS']?.split(',') ||
  DEFAULT_TRUSTED_PROTOCOLS;
const trustedDomains =
  process.env['NEXT_PUBLIC_TRUSTED_DOMAINS']?.split(',') ||
  DEFAULT_TRUSTED_DOMAINS;

export const reloadToBasePage = () => {
  window.location.href = window.location.origin;
};

export const redirectTo = (
  address: string | undefined,
  preserveQuery?: boolean,
  openInNewTab = false,
  onlyTrustedDomains = true,
) => {
  if (isNullOrUndefined(address)) {
    return;
  }

  preserveQuery = preserveQuery || false;

  const isRelative = !address.startsWith('http');

  // Create a URL object for the target URL
  let targetUrl: URL;
  if (isRelative) {
    // If the URL is relative, create an absolute URL
    const currentUrl = new URL(window.location.href);
    targetUrl = new URL(address, currentUrl.origin);
  } else {
    // If the URL is absolute, use it directly
    targetUrl = new URL(address);
  }

  if (!isRedirectSafe(targetUrl, onlyTrustedDomains)) {
    return;
  }

  if (preserveQuery) {
    // Get the current URL's query parameters
    const currentParams = new URLSearchParams(window.location.search);
    currentParams.forEach((value, key) => {
      targetUrl.searchParams.append(key, value);
    });
  }

  if (openInNewTab) {
    window.open(targetUrl.toString(), '_blank', 'noopener,noreferrer');
  } else {
    // Perform the redirect
    window.location.href = targetUrl.toString();
  }
};

export const reloadPage = () => {
  window.location.reload();
};

export function reloadPageWithoutQueryParams() {
  window.location.href = window.location.pathname;
}

export function getPageUrlWithoutQueryParams() {
  return window.location.href.split('?')[0];
}

export const getCurrentPath = () => {
  if (!window || !window.location) {
    return undefined;
  }

  return window.location.pathname;
};

const isTrustedDomain = (
  host: string,
  protocol: string,
  onlyTrustedDomains: boolean,
) => {
  if (!onlyTrustedDomains) {
    return true;
  }

  if (
    (protocol === 'http' || protocol === 'https') &&
    !trustedDomains.some(
      td => host === td || host.toLowerCase().endsWith('.' + td),
    )
  ) {
    return false;
  }

  return true;
};

const isRedirectSafe = (url: URL, onlyTrustedDomains: boolean) => {
  const protocol = url.protocol.slice(0, -1);

  if (!trustedProtocols.includes(protocol)) {
    return false;
  }

  if (!isTrustedDomain(url.host, protocol, onlyTrustedDomains)) {
    return false;
  }

  return true;
};
